import { lazy } from "react";

export const LazyApp = lazy(() => import("./App"));
